import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Spin } from 'antd'
import '../css/footer.css'
import { app, api } from "../app"
import wx_qrcode from '../assets/wx-qrcode.png'
import icp_png from '../assets/ICP.jpeg'
import y_icp from '../assets/y-icp.png'

class Footer extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            dl_loading: false
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDataList()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据列表
     * @returns {Promise<void>}
     */
    handleDataList = async () => {
        await this.setData({ dl_loading: true })
        let { flag, data, msg } = await app.post(api.BottomMenuLists)
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        await this.setData({ dl_loading: false, dataList: data })
    }

    render () {
        let { dl_loading, dataList } = this.state
        return (
            <div className="footer">
                <Row type="flex" justify="center">
                    <div className="f-wx">
                        <img src={wx_qrcode} alt="" className="fw-qr"/>
                        <div>微信客服</div>
                    </div>
                    {
                        dl_loading ? (<div className="dl-loading"><Spin/></div>) : dataList.map((dl, i) => {
                            return (
                                <div key={i} className="f-items">
                                    <div className="fi-title fi-item">{dl.name}</div>
                                    {
                                        dl.child.map((c, j) => {
                                            if (c.type === 2) {
                                                return (
                                                    <Link className="fi-item" key={i + '_' + j}
                                                          to="/videos">{c.name}</Link>
                                                )
                                            } else if (c.type === 3) {
                                                return (
                                                    <Link className="fi-item" key={i + '_' + j}
                                                          to={'/pro-author/' + c.name}>{c.name}</Link>
                                                )
                                            } else {
                                                return (
                                                    <Link className="fi-item" key={i + '_' + j}
                                                          to={"/other/" + c.name}>{c.name}</Link>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </Row>
                <div className="f-icp">
                    <Row style={{ width: '100%',paddingBottom:'10px' }}>
                        <Col span={10} className="fi-left">存心救援信息公开平台</Col>
                        <Col span={14} className="fi-left">技术支持及运营: 奥讯新媒体</Col>
                        {/*<Col span={12} className="fi-left">存心救援信息公开平台丨<a href="https://beian.miit.gov.cn" target="_blank" style={{color: '#fff'}}>粤B2-20051036号</a>丨技术支持及运营: 奥讯新媒体</Col>*/}
                        <Col span={10} className="fi-right">
                            <a href="https://beian.miit.gov.cn" target="_blank" style={{color: '#fff'}}>粤B2-20051036号</a>
                        </Col>
                        {/*<Col span={14} className="fi-right">*/}
                        {/*    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402002204" style={{height:'20px',lineHeight:'20px'}}><img src={y_icp} style={{float:'left'}}/><p style={{float:'left',height:'20px',lineHeight:'20px',margin:'0px 0px 0px 5px',color:'#FFF'}}>粤公网安备 44060402002204号</p></a>*/}
                        {/*</Col>*/}
                    </Row>
                </div>
            </div>
        )
    }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx